import styled from 'styled-components'

export const LinkStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const TextStyled = styled.div``
